import { useContext } from 'react'

import { useLegacyAnalytics } from '@lib/hooks/tracking/use-legacy-analytics'

import { PageContext } from '@contexts/page-context'

export function SHLegacyTracking(): null {
  const pageContext = useContext(PageContext)

  useLegacyAnalytics(pageContext)

  return null
}
